export const THIRD_PERSON_SUFFIX = '__third_person__'
